module.exports = __webpack_public_path__ + "static/media/menu.c6ce22fa.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/menu.svg
 ** module id = 627
 ** module chunks = 44
 **/